module.exports = __webpack_public_path__ + "img/coin-setting.690580ea.svg";